<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">他山之石></span>
        <span @click="GoreportOutside">学习他人></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>雷斌：聚焦监督首要职责 做细做实日常监督</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>
        <h3>监督是纪委监委的首要职责、基本职责。南漳县纪委监委坚持把监督挺在前面，定位向监督聚焦，责任向监督压实，力量向监督倾斜，依规依纪依法做好日常监督，在监督上全面从严、全面发力，创造性地把监督工作做深做细做实，不断把制度优势转化为治理效能，推动纪检监察工作高质量发展。,把信访举报作为纪律审查的线索的第一来源渠道，充分发挥其“预警器”和“晴雨表”作用，注重精准分析，提高办信质效，积极探索化解基层信访问题的新途径、新办法，不断推进信访举报工作高质量发展。</h3>
        <h3><b>　一、践行“两个维护”，压实管党治党政治责任</b></h3>
        <h3>(牢牢把握做细做实日常监督这一基本任务，提高政治站位，突出监督重点，推动管党治党政治责任落地生根。.11%。从村（社区）干部受处理具体案例来分析，两人或两人以上“抱团”违纪现象比较普遍。主要表现为以村支部书记、主任为核心，其他村组干部参与、共同“谋划”的利益“小团体”，成为违纪违法问题的高危群体。如，该市太平镇崔垱村、大王村从村支部书记到村委会委员，集体挪用粮食直补款、坐收坐支集体资金等，涉及村“两委”干部达5人。+体会交流+廉政党课”的方式召开了“一案一教育”警示教育大会，强化警示教育的感染力和说服力。</h3>
        <h3>一是围绕落实责任担当强化监督。认真履行协助县委全面从严治党职责，督促全县各级党组织认真履行主体责任，主动落实日常监督职责，使“两个责任”贯通协同、形成合力。认真落实“两谈话两报告”制度，督促49个单位党委（党组）书记、纪委书记定期报告政治生态、党风廉政建设和领导班子成员廉政状况；认真开展党风廉政建设责任制考核，2019年以来，先后对考核落后的4个单位“一把手”进行约谈，对1个领导班子和7名领导干部进行“一票否决”。-2018年在担任该所党支部书记、所长期间，违反中央八项规定精神、违反政治纪律、挪用公款、非法占有公共财物等，被群众多次举报。其中违反中央八项规定精神达3次之多，从党内警告处分直至给予留党察看。分析多次被举报受处分人员情况，国家工作人员71人，农村党员干部108人。其中村（社区）主职干部被举报频率较高，受处分达72人，占比40.22%。</h3>
        <h3>二是围绕落实党中央重大决策部署强化监督。组织召开县纪委十四届四次全会，及时贯彻落实中央和省、市纪委全会精神，结合南漳实际，制定全县纪检监察工作要点。加强对重大决策部署贯彻落实情况的监督，发现落实不及时、不具体、不严格相关单位23个，督促整改相关问题42个。深入开展“两严”专项检查，2019年以来，组建10个检查专班，针对三大攻坚战推进情况、党内政治生活制度执行情况等5个方面问题，对全县11个镇（区）和机构改革后新成立的市场监管局等8家单位开展监督检查，进一步强化各级党组织和党员干部的政治纪律和政治规矩意识。</h3>
        <h3>三是围绕严肃党内政治生活强化监督。聚焦提高党内政治生活的政治性、时代性、原则性、战斗性，严格执行新形势下党内政治生活若干准则，把党员干部政治言行与部门单位政治生态结合起来。紧盯党的领导、党的建设、选人用人等工作加强监督，坚持对所辖单位领导班子民主生活会召开情况进行督导检查，党委主要负责人定期向县纪委全会述责述廉并接受纪委委员询问，2019年以来，先后对83名拟提拔或重用、职级晋升的党员干部进行廉政意见审核，对2名科级干部明确提出不宜提拔或晋升的意见，对2名不适宜继续在现岗位任职的党员干部提出职务调整建议。</h3>
        <h3><b>　二、织密监督网络，构建“四位一体”监督格局</b></h3>
        <h3>探索完善监督体系，推动形成纪律监督、监察监督、派驻监督、巡察监督织“四位一体”监督格局，努力实现监督全覆盖。.76%，同比增长7.25%。主要原因是由于各地各单位受理信访举报的时间不同，信访人担心信访件未被受理或重视不够，在等待的过程中重复反映问题，导致重复访数量居高不下。2019年越级访15件次，同比下降57.14%。主要原因是枣阳市纪委监委领导班子认真执行定期下访接访制度，主要领导每周四固定接访，去年共接待群众面访36批次581人次，上访对象无一人越级访，有效缓解了全市大信访压力，越级访乱象得到了遏止；二是自办案件增加，上级转交件下降。2019年共受理信访举报995件，同比基本持平。其中本级自收573件，占57.59%，同比增长57.85%；上级转交办422件，占42.41%，同比下降33.02%。主要原因是随着全面从严治党不断向纵深推进，信访干部履职尽责意识不断增强，办信办访能力增强，加之信访渠道的通畅及日益拓宽，干部主动接访、带案下访、重点约访的机制发挥了积极作用，群众在本级信访诉求能够得到有效解决，越级向上反映问题大幅减少。三是信访反映村级干部增加，乡科级干部减少。2019年信访反映村（社区）人员419件，同比增长16.06%，反映乡科级干部198件，同比下降30.5%。从中不难看出在全面从严治党的高压态势下，不敢腐的震慑已经形成，不能腐的笼子正在扎牢，不想腐的自觉逐步增强，但从村干部信访举报持续增长的趋势显示，全面从严治党“最后一米”的问题还不够彻底，违反群众纪律和廉洁纪律类问题仍然居高不下，破坏了党群干群关系，蚕食了群众切身利益。  闵翼飞）</h3>
      <h3>一是强化纪律监督。用纪律立规矩、严约束，把纪律监督贯穿到党内生活、纪律建设、廉政教育、执纪问责等方面，提高监督工作的主动性。盯紧元旦、春节、端午等重要时间节点下发“节日禁令”，2019年以来，组织开展集中检查9轮，发现各类问题47个，下发督办函16份，责令整改面上问题47个，督促职能部门开展专项清理整治2次。紧抓“关键少数”，坚持向县“四大家”领导、各单位“一把手”发送廉政短信和廉政提醒函。.26%。从中可以看出“有问题找纪委”的现象还比较普遍，究其原因是信访举报渠道宣传的不细致、不到位，导致部分群众分不清什么问题该在本村（社区）或乡镇就能得到解决，什么问题该找公检法部门，什么问题该找纪委监委，部分群众“病急乱投医”的较为普遍，同时也额外增加了纪检监察机关办信办案工作量。三是能力素质不到位。监察体制改革后，纪委监委合署办公，部分干部尤其是基层纪检干部“熟纪不熟法”，或存在“偏科”“瘸腿”现象，办信办案能力不足，质量不高。再之，有的纪委书记、纪检委员一人身兼数职，对信访工作不上心、不研究、不投入，久而久之，成为了信访工作的“门外汉”，阻碍了信访工作高质量发展。</h3>
      <h3>二是强化监察监督。坚持从建章立制入手，对公职人员依法履职、秉公用权、廉洁从政从业以及道德操守情况实施监督，建立重大问题线索和重大复杂案件分析研判制度和提级办理制度。《监察法》颁布后，对全县监察对象进行统计摸底，梳理、新增监督对象9000余人，消除监督盲区；严肃查处涉嫌职务违法犯罪案件，2019年以来，共受理信访举报478件，立案审查219件，办理留置案件6件6人，增强了监察监督效能。</h3>
      <h3>三是强化派出监督。调整设立8个派出纪检组，充分发挥“派”的权威，以监督单位领导班子成员特别是“一把手”为重点对象，定期检查贯彻落实中央和省、市、县委重大决策部署情况、贯彻落实中央“八项规定”精神和纠正“四风”情况。实行“三重一大”报备和领导干部个人重大事项报告制度，为全县77家单位的领导班子成员及所辖二级单位主要负责人建立廉政档案。</h3>
      <h3>四是强化巡察监督。修订完善《十四届南漳县委巡察工作规划》，进一步深化拓展全覆盖范围，创新形成《十四届南漳县委村（社区）巡察工作规划》，明确全县机构改革后77个镇（区）、县直单位（部门）及303个村（社区）巡察全覆盖“路径图”。对第六轮、第七轮巡察的15个单位整改情况进行了回访督查，反馈的351个问题已督促整改到位325个，整改率分别为95.9%和90.8%，给予党纪政务处分21人，组织处理384人，清收清退资金395.9万元，推动完善制度147项。</h3>
      <h3><b>三、精准发现问题，强化监督执纪效能</b></h3>
      <h3>改进工作方式，坚持思想教育、政策感化、纪法威慑相结合，聚焦领导干部这个“关键少数”，把监督融入日常工作中，增强监督的精准性和实效性。</h3>
      <h3>　一是强化精准问责意识。以转作风、强担当为突破口，于2019年9月制定出台《南漳县党员干部作风建设“八严禁”》，组建21个工作专班，在全县范围内开展为期3个月的作风建设专项检查。截至目前，全县共发现违反“八严禁”问题76个，给予党纪政务处分10人，组织处理68人，通报曝光突出问题4期27起。聚焦中央八项规定精神执行情况，查处违纪问题41起，给予党纪政务处分25人，组织处理16人。</h3>
      <h3>二是坚决整治形式主义官僚主义。协助县委推进“担当年”活动，督促各级党组织严格落实“基层减负年”要求，2019年度县委发文同比下降50.6%、召开会议同比下降31.4%。出台《南漳县纪委关于加强对形式主义、官僚主义整治工作监督检查的办法》，建立“八查”工作法（即刀刃向内自己查、发动群众广泛查、深入基层一线查、确定专题专项查、紧盯关键重点查、派出监督常态查、整合资源联合查、异地互动交叉查），深入推进整治形式主义、官僚主义的各项举措落实落地。2019年以来，全县共查处各类形式主义、官僚主义问题140起，给予党纪政务处分18人，组织处理122人。</h3>
      <h3>三是聚焦重点领域开展专项治理。紧紧围绕纪检监察重点工作和巡查整改发现的问题，全力督战“三大攻坚战”，深入开展涉黑涉恶腐败及“保护伞”“黄赌毒”案件专项整治，坚持“一案双查”，严肃追责问责。2019年以来，全县查处扶贫领域违纪违规问题209件，给予党政纪处分8人，组织处理201人；助力防范化解重大风险，向公安机关移送案件3起；在环保领域，处理群众信访举报121件，督促整改河流“四乱”问题3起；查处涉黑涉恶腐败保护伞和“黄赌毒”问题线索63件，立案31人，党纪政务处分22人，留置2人，移送司法机关1人。  金国江）</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/bannertest1.jpg"),
      PicBannertest2: require("../../../../assets/image/bannertest2.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    },
    GoreportOutside(){
      this.$router.push({ name: "forumOutside" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
   text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b{
    display: block;
    margin-top: 20px;
}
img{
  margin: 20px 0px;
}
.mg-16{
  margin: 0px 16px;
}
</style>